import { render, staticRenderFns } from "./mural-eletronico.vue?vue&type=template&id=50bd3fe9"
import script from "./mural-eletronico.vue?vue&type=script&lang=ts"
export * from "./mural-eletronico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports